import { PredpisItem, PredpisListExternalApi } from 'publikator-frontend-ts-axios';
import NajnovsiObsahTableItem from '../model/NajnovsiObsahTableItem';
import { ClientResponse } from '../model/ClientResponse';
import { publikatorPrefixPath } from '../configuration/apiConfigurationConstants';
import apiConfiguration from '../configuration/apiConfiguration';

const client = new PredpisListExternalApi(apiConfiguration(publikatorPrefixPath));

function mapVyhlasenyPredpis(predpisList: PredpisItem[]): NajnovsiObsahTableItem[] {
  return predpisList.map((predpis) => ({
    id: predpis.iri,
    cislo: predpis.cislo,
    nazov: predpis.nazov,
    redirectUrl: predpis?.iri?.includes('SK/OP/')
      ? `/ezbierky/chronologicky-register-opatreni${predpis.iri}`
      : `/ezbierky/pravne-predpisy${predpis.iri}`,
    vyhlaseny: new Date(`${predpis.datumVyhlasenia}`),
  }));
}

export const fetchVyhlasenePredpisy = async (): Promise<ClientResponse<NajnovsiObsahTableItem[]>> => {
  const {
    data,
    status,
  } = await client.getLatestPublikovanyPredpisList();
  return {
    data: mapVyhlasenyPredpis(data),
    responseCode: status,
  };
};
